// extracted by mini-css-extract-plugin
module.exports = {"label":"CodeInput_label__1PVlR","containerCode":"CodeInput_containerCode__M1NnQ","inputCode":"CodeInput_inputCode__1AHv3","btn":"CodeInput_btn__1HOYF"};